import { selectIsWhatsAppMessageChannelGAFlagOn } from 'core/userContext/selectors';
import { useSendingPlatformsQueryContext } from 'modules/sendingPlatforms/contexts';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { H4, spacing } from 'ui/theme';
import { SendingPlatform } from '../../../constants';
import { ContinueWithFacebookButton } from './ContinueWithFacebookButton';

export const Header = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: ${spacing.plusHalf};
  white-space: nowrap;
`;

export const Heading = styled(H4)`
  margin-bottom: 0;
  margin-right: ${spacing.base};
`;

type Props = { sendingPlatform: SendingPlatform };

export const WhatsAppAccountsHeader = ({ sendingPlatform }: Props) => {
  const isWhatsAppGAEnabled = useSelector(selectIsWhatsAppMessageChannelGAFlagOn);
  const { espAccountsBySendingPlatform } = useSendingPlatformsQueryContext();

  const espAccounts = espAccountsBySendingPlatform[sendingPlatform] || [];

  return (
    <Header data-test="sending-platform-details-accounts-header">
      <Heading>{isWhatsAppGAEnabled ? 'WhatsApp Business ' : ''}Accounts</Heading>
      {!!espAccounts?.length && <ContinueWithFacebookButton />}
    </Header>
  );
};
